import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";
import { process } from "../../data/siteData";

const ProcessSteps = () => {
  return (
    <Box
      component="section"
      sx={{ py: "64px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        <Box sx={{ mb: "40px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              HOW WE WORK
            </Box>
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(30px,3.6vw,44px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            A clear path from diagnosis to lasting impact
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4,1fr)",
            },
            gap: "16px",
          }}
        >
          {process.map((p) => (
            <Box
              key={p.num}
              sx={{
                background: "#fff",
                border: `1px solid ${colors.lineSoft}`,
                borderRadius: "22px",
                p: "30px 26px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 700,
                  fontSize: "54px",
                  lineHeight: 1,
                  color: "#EEF2F7",
                }}
              >
                {p.num}
              </Box>
              <Box
                component="h3"
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 600,
                  fontSize: "18.5px",
                  color: colors.navyInk,
                  mt: "8px",
                  mb: 0,
                }}
              >
                {p.title}
              </Box>
              <Box
                sx={{
                  fontFamily: fonts.body,
                  fontSize: "14px",
                  lineHeight: 1.6,
                  color: "#6A7888",
                  mt: "10px",
                }}
              >
                {p.body}
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  top: "30px",
                  right: "26px",
                  width: "9px",
                  height: "9px",
                  borderRadius: "50%",
                  background: colors.amber,
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ProcessSteps;
